import { AdminImportStyle } from "Main/Admin/AdminImportStyle";
import { DeskCsvImport } from "Main/Admin/DeskCsvImport";
import { PodCsvImport } from "Main/Admin/PodCsvImport";
import useLang from "Shared/Context/LangContext";

export const AdminImport = () => {

    const { curLangData } = useLang();

    return (
        <AdminImportStyle.Container>
            <AdminImportStyle.Intro>
                {curLangData?.text.CsvImportPageIntro}
            </AdminImportStyle.Intro>

            <AdminImportStyle.CardGrid>
                <DeskCsvImport />
                <PodCsvImport />
            </AdminImportStyle.CardGrid>
        </AdminImportStyle.Container>
    );
};
